/**
 * A global namespace for aria-haspopup.
 */
const ariaHasPopup = "aria-haspopup";
export default ariaHasPopup;
